import { PlusSmallIcon, XCircleIcon } from "@heroicons/react/24/outline";
import React, { useRef } from "react";
import { RefreshIcon } from "../../asssets/icons";

const ImageUploader = ({ label = "Image", image, setImage, uploadProgress }) => {
  const localInputRef = useRef(null);

  const getImageLink = (value) => {
    // new image
    if (value?.type) {
      return URL.createObjectURL(value);
    }
    return process.env.REACT_APP_AWS_URL + value;
  };

  return (
    <div className="flex flex-col w-full gap-2">
      <div className="border-2 border-gray-500 rounded my-2 p-4">
        <p className="text-base font-bold text-[#191919] mb-2">{label}</p>
        <div className="group relative block">
          {/* Remove Icon */}
          <div
            className="hidden group-hover:block absolute -top-2 -right-2 w-6 h-6 bg-black cursor-pointer rounded-full z-10"
            onClick={() => {
              setImage(null);
              if (localInputRef.current) localInputRef.current.value = "";
            }}>
            <XCircleIcon className="w-6 h-6 text-red-500" />
          </div>
          <div
            className="relative block w-full group cursor-pointer"
            onClick={() => {
              if (localInputRef.current) localInputRef.current.click();
            }}>
            {/* Reload logo */}
            <div className="hidden group-hover:flex absolute top-0 left-0 bottom-0 right-0 w-full h-full bg-black opacity-50 cursor-pointer items-center justify-center">
              <span className="w-8 h-8">
                <RefreshIcon color="#FFFFFF" />
              </span>
            </div>

            {image && (
              <div className="bg-[#F9F9F9] rounded-md p-4 w-[200px] h-[200px] mx-auto">
                <div className="w-full h-full rounded-full overflow-hidden">
                  <img
                    src={getImageLink(image)}
                    className="w-full h-full object-cover cursor-pointer"
                    alt=""
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        {!image && (
          <div className="w-full bg-[#ffffff] rounded relative px-4 py-3 cursor-pointer mt-2">
            <div
              className="flex justify-start items-center gap-4 px-4 py-3 cursor-pointer shadow-sm"
              onClick={() => {
                localInputRef.current.click();
              }}>
              <PlusSmallIcon
                className={`w-7 h-7 stroke-2 stroke-white bg-[#E3E3E3] rounded-full`}
              />
              <span className="text-sm text-gray-600">Click to upload image</span>
            </div>
          </div>
        )}

        <input
          ref={localInputRef}
          type="file"
          accept="image/*"
          name="image"
          onChange={(event) => {
            setImage(event.currentTarget.files[0]);
          }}
          className={"hidden"}
        />
      </div>

      {uploadProgress !== undefined && uploadProgress > 0 && uploadProgress < 1 && (
        <div className="bg-gray-100 w-full relative h-6 rounded-md overflow-hidden mt-2">
          <div
            className="bg-corange-100 h-full text-white text-center flex items-center justify-center"
            style={{
              width: `${uploadProgress * 100}%`
            }}>
            <p className="text-sm text-white">{(uploadProgress * 100).toFixed(2)}%</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
